import "./styles.scss";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ReactComponent as CheckIcon } from "assets/icons/new/check.svg";
import { ReactComponent as ErrorIcon } from "assets/icons/new/error.svg";
import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";

const mainClass = "development-mobile";

const DevelopmentMobile = ({
  available,
  left,
  exceeding,
  moreHref,
  variant = "default",
}) => {
  const { t } = useTranslation();
  const isDashboard = variant === "dashboard";

  return (
    <div
      className={`${mainClass}${isDashboard ? ` ${mainClass}--dashboard` : ""}`}
    >
      {isDashboard ? (
        <>
          <div className={`${mainClass}__header`}>
            <h6>{t("Development work")}</h6>
            {moreHref && (
              <Link to={moreHref}>
                {t("See more")}
                <i>
                  <ArrowIcon />
                </i>
              </Link>
            )}
          </div>
          <p className={`${mainClass}__description`}>
            {t(
              "See how much time you’ve used for development work on your site this month.",
            )}
          </p>
        </>
      ) : (
        <h6>{t("Development work")}</h6>
      )}
      <div className={`${mainClass}__progress`}>
        <div className={`${mainClass}__progress-item`}>
          <i>
            <CheckIcon />
          </i>
          <p>
            {t("Time left")}: <strong>{left}</strong>
          </p>
        </div>
        <div
          className={`${mainClass}__progress-item ${mainClass}__progress-item--exceeding`}
        >
          <i>
            <ErrorIcon />
          </i>
          <p>
            {t("Time exceeding plan")}: <strong>{exceeding}</strong>
          </p>
        </div>
      </div>
      <p>
        {t("Time available in your plan")}: {available}
      </p>
    </div>
  );
};

export default DevelopmentMobile;
